import React from 'react';
import SimpleItem from './SimpleItem';
export default class List extends React.Component {
	render () {
		const { courses, selectedId, selected } = this.props;

		return (
			<div className="w-40 flex-shrink-0 mr-12">
				{courses.map((course, i) => <SimpleItem key={'simple-' + course.id} course={course} selected={selected} selectedId={selectedId} />)}
			</div>
		);
	}
}
